import React from 'react'
import config from 'config'
import { get } from 'lodash'

import {
  PaymentGPInit,
  PaymentSuccess,
  PaymentGPFail
} from 'containers/pages'

const urlPrefix = `${config.publicPath}`

export default [
  {
    path: `${urlPrefix}/gp-init/:orgId/:authCode`,
    exact: true,
    component: props => (
      <PaymentGPInit
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/gp-success/`,
    exact: true,
    component: props => (
      <PaymentSuccess
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/gp-error/`,
    exact: true,
    component: props => (
      <PaymentGPFail
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/gp-error/:orgId/:authCode`,
    exact: true,
    component: props => (
      <PaymentGPFail
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  }
]


